import {isRunningInDevelopmentMode} from './utils'

const devMode = isRunningInDevelopmentMode()

const getDevUser = () => {
  if (devMode) {
    return {
      firstName: 'Krisztián Mátyás',
      lastName: 'Haragos',
      email: 'haragos.matyas@simiaalba.hu',
      uuid: 'c4b5fb9f-fcda-4c30-9571-35d865a4ea35',
      partyTypeEnum: 'ADMINISTRATOR'
    }
  }
  throw new Error('Not running in development mode')
}

export default {
  baseUrl: devMode ? 'http://identity-platform.local:3010' : '',
  devMode: devMode,
  getDevUser: getDevUser,
  forgotPasswordEnabled: true,
  routes: {
    login: '/login',
    forgotPassword: '/forgot-password'
  }
}



// WEBPACK FOOTER //
// ./src/config.js